import { apiClient } from './apiConfig';

export interface MercuryStatus {
  connected: boolean;
  last_synced_at?: string;
  created_at?: string;
}

export interface MercurySyncResult {
  accounts: { created: number; updated: number; total: number };
  transactions: { created: number; updated: number };
}

export const mercuryAPI = {
  getStatus: async (): Promise<MercuryStatus> => {
    const response = await apiClient.get('/api/mercury/status/');
    return response.data;
  },

  saveConnection: async (apiKey: string): Promise<any> => {
    const response = await apiClient.post('/api/mercury/save/', { api_key: apiKey });
    return response.data;
  },

  sync: async (days: number = 90): Promise<MercurySyncResult> => {
    const response = await apiClient.post('/api/mercury/sync/', { days });
    return response.data;
  },

  disconnect: async (): Promise<any> => {
    const response = await apiClient.post('/api/mercury/disconnect/');
    return response.data;
  },
};
